import { Link } from 'react-router-dom';
import SEOHead from '../components/SEOHead';

const CONTACT_EMAIL = 'optionview580@gmail.com';

export default function Contact() {
  return (
    <>
      <SEOHead
        title="Contact Us"
        description="Contact the OptionView team — questions, feedback, bug reports or partnership inquiries for India's free IV calculator."
        canonicalPath="/contact"
      />

      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-10">
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Contact Us</h1>
        <p className="text-gray-600 mb-8">
          We'd love to hear from you. Questions, feedback, bug reports — all welcome.
          We typically respond within 24–48 hours.
        </p>

        {/* Email card */}
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-6 mb-8">
          <p className="text-sm font-medium text-blue-700 mb-1">Email us at</p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-xl font-semibold text-blue-900 hover:underline break-all"
          >
            {CONTACT_EMAIL}
          </a>
          <p className="text-xs text-blue-600 mt-2">We aim to respond within 24–48 hours.</p>
        </div>

        {/* What you can contact us about */}
        <div className="bg-white rounded-lg border border-gray-200 p-6 mb-8 space-y-3">
          <h2 className="text-lg font-semibold text-gray-900">What You Can Contact Us About</h2>
          <ul className="space-y-2 text-sm text-gray-700">
            <li className="flex gap-2">
              <span className="text-blue-500">✓</span>
              <span><strong>Questions</strong> about how to use the IV calculator or interpret results</span>
            </li>
            <li className="flex gap-2">
              <span className="text-blue-500">✓</span>
              <span><strong>Feedback and suggestions</strong> for new features or improvements</span>
            </li>
            <li className="flex gap-2">
              <span className="text-blue-500">✓</span>
              <span><strong>Bug reports</strong> — if you spot incorrect data or a broken feature</span>
            </li>
            <li className="flex gap-2">
              <span className="text-blue-500">✓</span>
              <span><strong>Partnership inquiries</strong> — brokers, fintech companies, educational platforms</span>
            </li>
            <li className="flex gap-2">
              <span className="text-blue-500">✓</span>
              <span><strong>Media inquiries</strong> — press coverage, interviews, or mentions</span>
            </li>
          </ul>
        </div>

        {/* Please note */}
        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 text-sm text-amber-800 mb-6">
          <p className="font-semibold mb-1">Please note:</p>
          <ul className="space-y-1 list-disc pl-4">
            <li>We <strong>cannot provide personalised trading advice</strong> or recommend specific trades.</li>
            <li>For common questions, check our <Link to="/faq" className="underline font-medium">FAQ page</Link> first — your answer may already be there.</li>
            <li>For urgent issues, email is the fastest way to reach us.</li>
          </ul>
        </div>

        <p className="text-xs text-gray-400">
          OptionView is a free tool. We are a small team — please be patient if response times
          are slightly longer than usual.
        </p>
      </div>
    </>
  );
}
